webpackJsonp([170680017877617],{

/***/ 354:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulBlog":{"title":"Concert in Killasser Church","slug":"concert-in-killasser-church","metaDescription":"Jerry O'Sullivan plays the Uilleann Pipes and launches a CD","body":{"childMarkdownRemark":{"html":"<p>Jerry O'Sullivan plays the Uilleann Pipes and launches a CD. This takes in Killasser Church. Tea will be served in Community Centre afterwards and the CD will be on sale.</p>\n<p>Find out more information about Jerry and his music at his <a href=\"https://sites.google.com/site/jerrythepiper/\" title=\"Jerry O&#x27;Sullivan Web Site\">website</a>.</p>"}},"featuredImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/2kVcWzW2VyME2YC8sEok66/107e2fbed54f04aef20d9b770bf2bada/jerry-profile.jpg"}}}},"pathContext":{"slug":"concert-in-killasser-church"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-concert-in-killasser-church-6a9999d292562a3f2f03.js